import { render, staticRenderFns } from "./Proposers.vue?vue&type=template&id=48658dc6&scoped=true&"
import script from "./Proposers.vue?vue&type=script&lang=js&"
export * from "./Proposers.vue?vue&type=script&lang=js&"
import style0 from "./Proposers.vue?vue&type=style&index=0&id=48658dc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48658dc6",
  null
  
)

export default component.exports